<app-form-view [formDataModel]="addressType"
    [formItems]="addressTypeFormItems"
    (onSave)="onSaveClicked($event)"
    (onCancel)="onCancelClicked($event)"></app-form-view>